import { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'redux-first-history';
import { CHECKBOX_STATUS } from 'ui/checkbox';
import { Badge } from 'ui/badge';
import { Body2 } from 'ui/theme';

import { GridRow, HeaderGridRow } from 'ui/indexPages/tables/grid';
import { CheckboxGridCell } from 'ui/indexPages/tables/cells';

import { TableHeaderButton } from './components/TableHeaderButton';
import { WorkflowWebhookOverflowMenu } from './components/WorkflowWebhookOverflowMenu';
import { WorkflowWebhookNameCell } from './components/WorkflowWebhookNameCell';
import { SkeletonRows } from './components/SkeletonRows';
import { GeneralEmptyState, NoResults } from './components/EmptyState';

import { StyledGroupSelect, TableCell } from './WorkflowWebhookIndexTable.styles';
import { WORKFLOW_WEBHOOK_GRIDS, WORKFLOW_WEBHOOK_INDEX_COLUMNS } from './constants';
// import { WorkflowWebhookTableColumn } from './types';
// import { WorkflowWebhook } from '../workflowWebhooks/types';
// import { SORT_DIRECTIONS } from 'constants/sortDirections';

// type Props = {
//   columns: WorkflowWebhookTableColumn[],
//   /** Id of column currently used to sort table rows */
//   sortBy: string,
//   /** Function run to set column to sort table rows by */
//   setSortBy: () => {},
//   /** Sort direction */
//   sortDirection: SORT_DIRECTIONS.ASCENDING | SORT_DIRECTIONS.DESCENDING,
//   /** Function run to set new sort direction */
//   setSortDirection: () => {},
//   /** List of WorkflowWebhooks used to populate table rows */
//   workflowWebhooks: WorkflowWebhook[],
//   /** List of workflow webhook ids indicated currently selected workflow webhook rows */
//   selected: number[],
//   /** Function run to toggle selection of workflow webhook */
//   toggleSelection: () => {},
//   /** Function run to select all workflow webhook */
//   selectAll: () => {},
//   /** Function run to deselect all workflow webhooks */
//   deselectAll: () => {},
//   /* Function run to refetch the data for the table */
//   refetch: () => {},
//   /** True if data for the table is still being loaded */
//   isLoading: boolean,
//   /** True if filters from the filter menu or tabs are being applied */
//   hasFilters: boolean,
//   /** Function run to open archive modal */
//   setShowArchiveModal: () => {},
//   /** Function run to open unarchive modal */
//   setShowUnarchiveModal: () => {},
// };

export const WorkflowWebhookIndexTable = ({
  columns = WORKFLOW_WEBHOOK_INDEX_COLUMNS,
  sortBy,
  setSortBy,
  sortDirection,
  setSortDirection,
  workflowWebhooks = [],
  selected = [],
  toggleSelection,
  selectAll,
  deselectAll,
  isLoading = false,
  hasFilters = false,
  setShowCopyModal,
  setShowDeleteModal,
}) => {
  const [previousCount, setPreviousCount] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    setPreviousCount(workflowWebhooks.length);
  }, [workflowWebhooks.length]);
  /**
    Calculate the display value for the group select checkbox
   */
  let groupSelectStatus = CHECKBOX_STATUS.INDETERMINATE;
  if (selected.length === 0) {
    groupSelectStatus = CHECKBOX_STATUS.UNCHECKED;
  } else if (selected.length === workflowWebhooks.length) {
    groupSelectStatus = CHECKBOX_STATUS.CHECKED;
  }

  const showEmptyStateMessage = !isLoading && workflowWebhooks.length === 0;
  return (
    <div data-test="workflow-webhook-index-table">
      <HeaderGridRow gridLayout={WORKFLOW_WEBHOOK_GRIDS}>
        <StyledGroupSelect
          onSelectAll={selectAll}
          onSelectNone={deselectAll}
          status={groupSelectStatus}
        />
        {columns.map((column) => (
          <TableHeaderButton
            key={column.id}
            sortDirection={sortDirection}
            onSortByChange={setSortBy}
            onSortDirectionChange={setSortDirection}
            isActiveSortColumn={column.id === sortBy}
            isSortable
            {...column}
          />
        ))}
      </HeaderGridRow>
      {isLoading ? (
        <SkeletonRows numRows={previousCount} />
      ) : (
        workflowWebhooks.map((workflowWebhook) => {
          // const methodBadgeVariant = BADGE_VARIANTS_FOR_WORKFLOW_WEBHOOK[workflowWebhook.method];
          return (
            <GridRow gridLayout={WORKFLOW_WEBHOOK_GRIDS} key={workflowWebhook.id}>
              <CheckboxGridCell
                data-test={`checkbox-${workflowWebhook.id}${
                  selected.includes(workflowWebhook.id) ? '-selected' : ''
                }`}
                id={workflowWebhook.id}
                handleClick={() => toggleSelection(workflowWebhook.id)}
                status={
                  selected.includes(workflowWebhook.id)
                    ? CHECKBOX_STATUS.CHECKED
                    : CHECKBOX_STATUS.UNCHECKED
                }
              />
              <WorkflowWebhookNameCell workflowWebhook={workflowWebhook} />
              <TableCell data-test="workflow-webhook-index-method-cell">
                <Badge variant="info">{workflowWebhook.method}</Badge>
              </TableCell>
              <TableCell data-test="workflow-webhook-index-endpoint-cell">
                <Body2>{workflowWebhook.endpoint}</Body2>
              </TableCell>
              {/* Endpoint */}
              <WorkflowWebhookOverflowMenu
                workflowWebhook={workflowWebhook}
                editWorkflowWebhook={() =>
                  dispatch(push(`/workflows/webhooks/${workflowWebhook.id}`))
                }
                showCopyModal={() => setShowCopyModal([true, workflowWebhook])}
                showDeleteModal={() => {
                  setShowDeleteModal([true, [workflowWebhook]]);
                }}
              />
            </GridRow>
          );
        })
      )}
      {showEmptyStateMessage && (hasFilters ? <NoResults /> : <GeneralEmptyState />)}
    </div>
  );
};
